import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";
import CoinInfoLayout, { COIN_INFO_TYPES } from "../../layouts/CoinInfoLayout";
import WithI18next from "../../components/WithI18next";

const CoinInfoPage = ({ data, t, location }) => {
  const search = new URLSearchParams(location.search);
  const type = search.get("type");
  const isCoinTypeExisted = Object.values(COIN_INFO_TYPES).indexOf(type) >= 0;
  const coinType = isCoinTypeExisted ? type : COIN_INFO_TYPES.LISTED_COIN;

  return (
    <Layout
      title={t("coinInfo.seo.title")}
      description={t("coinInfo.seo.description")}
    >
      <CoinInfoLayout data={data} coinType={coinType} />
    </Layout>
  );
};

export default WithI18next()(CoinInfoPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    listedCoins: allWpCoinInfoItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { fields: acfCoinInfo___ciHomeFullName }
    ) {
      nodes {
        slug
        acfCoinInfo {
          ciHomeShortName
          ciHomeFullName
          ciHomeImage {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 400, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }

    newListedCoins: allWpNewCoinInfoItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        language: { locale: { eq: $wpLocale } }
        categories: { nodes: { elemMatch: { slug: { eq: "listed-coin" } } } }
      }
      sort: { fields: acfCoinInfo___ciHomeFullName }
    ) {
      nodes {
        slug
        acfCoinInfo {
          ciHomeFullName
          ciTickerSymbol
          ciHomeFeaturedImage {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 400, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }

    zLaunchCoins: allWpNewCoinInfoItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        language: { locale: { eq: $wpLocale } }
        categories: { nodes: { elemMatch: { slug: { eq: "zlaunch-coin" } } } }
      }
      sort: { fields: acfCoinInfo___ciHomeFullName }
    ) {
      nodes {
        slug
        excerpt
        acfCoinInfo {
          ciIcon {
            localFile {
              publicURL
            }
          }
          ciHomeFullName
          ciTickerSymbol
        }
      }
    }

    coinZMT: file(relativePath: { eq: "images/coin-info-zmt.png" }) {
      childImageSharp {
        gatsbyImageData(width: 400, layout: CONSTRAINED)
      }
    }
  }
`;
